import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArchive,
  faArrowDown,
  faArrowUp,
  faCheck,
  faCheckSquare,
  faCopy,
  faCube,
  faEdit,
  faEllipsisH,
  faInfo,
  faMapMarked,
  faPaperclip,
  faPhone,
  faPlus,
  faPrint,
  faStickyNote,
  faTasks,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Vue.config.productionTip = false;
library.add(
  faArchive,
  faArrowDown,
  faArrowUp,
  faCheck,
  faCheckSquare,
  faCopy,
  faCube,
  faEdit,
  faEllipsisH,
  faInfo,
  faMapMarked,
  faPaperclip,
  faPhone,
  faPlus,
  faPrint,
  faStickyNote,
  faTasks,
  faTrashAlt,
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(BootstrapVue);

import "@/styles/global.scss";

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
